export default "__VITE_ASSET__C4vPB93D__"